import invokeApi from '#/utils/invokeApi'

export function searchAddresses(
  payload: TopHap.Service.SearchAddressesRequest,
  abortController?: AbortController
) {
  return invokeApi<TopHap.Service.ListResponse<TopHap.Place>>({
    endpoint: '/v4/geo/addresses',
    method: 'GET',
    query: payload,
    withUserId: true,
    abortController
  })
}

export function getAddresses(ids: string[] | string, abortController?: AbortController) {
  return invokeApi<TopHap.Service.ListResponse<TopHap.Place>>({
    endpoint: '/v4/geo/addresses/[{ids}]',
    method: 'GET',
    path: { ids: typeof ids === 'string' ? ids : ids.join(',') },
    abortController
  })
}

export function getZones(
  ids: string[],
  abortController?: AbortController
) {
  return invokeApi<TopHap.Service.GetZonesResponse>({
    endpoint: '/v4/geo/zones',
    method: 'POST',
    body: { ids },
    abortController
  })
}
